import { useSelectedTeam } from "features/team-settings/hooks";
import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Returns whether agent work features should be shown, plus a loading
 * flag to avoid premature redirects before team data has loaded.
 */
export const useAgentWorkFlag = (): {
  enabled: boolean;
  isLoading: boolean;
} => {
  const { selectedTeam } = useSelectedTeam();
  const isLoading = selectedTeam === undefined;
  const hasTeamFeature =
    selectedTeam?.enabledFeatures?.includes("AGENT_WORK") ?? false;
  const hasUrlFlag = useFeatureFlag("agentWork");
  return { enabled: hasTeamFeature && hasUrlFlag, isLoading };
};
